<h5 class="mode-nav-header" [class.analyst-studio]="isAnalystStudio$ | async">Home</h5>
<ul [class.analyst-studio]="isAnalystStudio$ | async">
  <li *ngIf="personalCollectionToken">
    <a
      [modeLegacyRouterLink]="['/', currentOrg?.username, 'spaces', personalCollectionToken]"
      modeLegacyRouterLinkActive="selected"
      [target]="target"
    >
      <capra-icon icon="icon-home"></capra-icon>
      <div class="title">Personal</div>
    </a>
  </li>
  <li>
    <a
      [modeLegacyRouterLink]="['/home', currentOrg?.username, 'search']"
      modeLegacyRouterLinkActive="selected"
      [target]="target"
      data-intercom="home-nav-my-work"
    >
      <capra-icon icon="icon-pencil"></capra-icon>
      <div class="title">My Work</div>
    </a>
  </li>
  <li *ngIf="(isAnalystStudio$ | async) === false">
    <a
      [modeLegacyRouterLink]="['/home', currentOrg?.username, 'explorations']"
      modeLegacyRouterLinkActive="selected"
      [target]="target"
    >
      <capra-icon icon="icon-light-bulb"></capra-icon>
      <div class="title">My Explorations</div>
    </a>
  </li>
  <li>
    <a
      [modeLegacyRouterLink]="['/home', currentOrg?.username, 'starred']"
      modeLegacyRouterLinkActive="selected"
      [target]="target"
    >
      <capra-icon icon="icon-star-unfilled"></capra-icon>
      <div class="title">Starred</div>
    </a>
  </li>
  <ng-container *ngIf="currentOrg?.isFreePlan === false && currentOrg?.user === false">
    <li>
      <a
        [modeLegacyRouterLink]="['/home', currentOrg?.username, 'reports']"
        modeLegacyRouterLinkActive="selected"
        [target]="target"
      >
        <capra-icon icon="icon-eye"></capra-icon>
        <div class="title">Recently Viewed</div>
      </a>
    </li>
  </ng-container>
  <li
    *ngIf="
      (currentOrg?.isFreePlan === false && currentOrg?.user === false) ||
      (currentOrg?.isFreePlan === true && isEnableDiscoverPageForStudioPlanEnabled)
    "
  >
    <a
      [modeLegacyRouterLink]="['/home', currentOrg?.username, 'discover']"
      modeLegacyRouterLinkActive="selected"
      [target]="target"
    >
      <capra-icon icon="icon-discover"></capra-icon>
      <div class="title">Discover</div>
    </a>
  </li>
</ul>
